<template>
  <div class="progressContainer">
    <h2 class="section-heading">SECTION {{ sectionName }}</h2>
    <ProgressBar :progress="progress" gradient="linear-gradient(270deg, #FD8D8D, #ffa3a3)" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import type { Ref, ComputedRef } from 'vue'

// Components
import ProgressBar from '@/components/ProgressBar.vue'

// Stores
import { storeToRefs } from 'pinia'
import { useDataStore } from '@/stores/DataStore'

const dataStore = useDataStore()
const { currentSubtest, currentQuestion } = storeToRefs(dataStore)

const QUESTIONS_PER_SECTION = 7

// Progress calculated based on the current section
const progress: ComputedRef<number> = computed(() => {
  if (!currentQuestion.value) return 0
  const totalQuestions = currentSubtest.value!.questions!.length
  const currentQuestionIndex = currentQuestion.value.index

  const currentSection = Math.floor(currentQuestionIndex / QUESTIONS_PER_SECTION)
  const questionInSection = (currentQuestionIndex % QUESTIONS_PER_SECTION) + 1

  const isLastSection = (currentSection + 1) * QUESTIONS_PER_SECTION >= totalQuestions
  const questionsInCurrentSection = isLastSection
    ? totalQuestions - currentSection * QUESTIONS_PER_SECTION
    : QUESTIONS_PER_SECTION

  return (questionInSection / questionsInCurrentSection) * 100
})

const sectionName = computed(() => {
  if (currentQuestion.value === undefined) return ''
  const sectionNumber = Math.floor(currentQuestion.value!.index / QUESTIONS_PER_SECTION)
  return sectionNames[sectionNumber]
})

const sectionNames = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten']
</script>
<style scoped lang="scss">
.progressContainer {
  position: absolute;
  min-height: 0;
  width: calc(var(--full-vw) * 0.4);
  bottom: 20px;
  right: calc(var(--full-vw) * 0.03);
}

.progressContainer .progress-bar {
  width: 100% !important;
  height: 8px !important;
}

.section-heading {
  text-transform: uppercase;
  color: $secondary;
  text-align: right;
}

@media (max-height: 500px), (max-width: 500px) {
  .section-heading {
    font-size: 1em;
  }
}
</style>
